import { paths } from 'src/routes/paths';

import packageJson from '../package.json';

// ----------------------------------------------------------------------
const CONFIG_MAP = {
  Development: {
    serverUrl: 'https://backoffice.ncp-dev.dev-i.net',
    assetURL: 'https://backoffice.ncp-dev.dev-i.net/backoffice',
  },
  Testing: {
    serverUrl: 'https://backoffice.ncp-test.dev-i.net',
    assetURL: 'https://backoffice.ncp-test.dev-i.net/backoffice',
  },
  Production: {
    serverUrl: 'https://backoffice.ncp-sys.com',
    assetURL: 'https://backoffice.ncp-sys.com/backoffice',
  },
  Load: {
    serverUrl: 'https://backoffice.ncp-load.com',
  },
  WAProduction: {
    serverUrl: 'https://backoffice.ncp.watechnology.com',
  }
};
export const CONFIG = {
  site: {
    name: 'Onseo',
    ...CONFIG_MAP[process.env.REACT_APP_ENVIRONMENT || 'Testing'],
    basePath: process.env.REACT_APP_BASE_PATH ?? '',
    version: packageJson.version,
  },
  /**
   * Auth
   * @method jwt | amplify | firebase | supabase | auth0
   */
  auth: {
    method: 'jwt',
    skip: false,
    redirectPath: paths.dashboard.gameConfiguration.list,
  },
  /**
   * Mapbox
   */
  mapbox: {
    apiKey: process.env.REACT_APP_MAPBOX_API_KEY ?? '',
  },
};
